















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { DateSchedule } from '@/types/schedule'
import { DateString } from '@/types/utils'
import ScheduleListItem from './ScheduleListItem.vue'
import dayjs from 'dayjs'

@Component({
  components: {
    ScheduleListItem
  }
})
export default class ScheduleList extends Vue {
  readonly wrapperId = 'schedule-list-wrapper'
  @Prop({ default: '2020-01-01' })
  today!: DateString

  @Prop({ default: '2020-01-01' })
  targetDate!: DateString

  @Prop({ default: [] })
  schedules!: DateSchedule[]

  @Watch('targetDate')
  onTargetDateChanged(value: DateString) {
    this.scrollToDate(value)
  }

  @Watch('schedules')
  onScheduleChanged() {
    Vue.nextTick(() => {
      this.scrollToDate(this.targetDate)
    })
  }

  getHeaderText(date: string): string {
    return dayjs(date)
      .locale('ja')
      .format('M月D日')
  }

  getElementTop(el: HTMLElement) {
    const wrapperEl = document.getElementById(this.wrapperId)
    if (!wrapperEl) return 0
    wrapperEl.scrollTop = 0
    const rect = el.getBoundingClientRect()
    const wrapperRect = wrapperEl.getBoundingClientRect()
    const style = window.getComputedStyle(wrapperEl)
    const padding = parseInt(style.paddingTop.replace('px', ''))
    return rect.top - wrapperRect.top - padding
  }

  getDateElement(date: DateString) {
    if (!this.schedules.length) return
    const days = this.schedules.map(s => s.date)
    if (days.includes(date)) {
      return document.getElementById(date)
    }
    const target = dayjs(date)
    const nearestDate = days.reduce((a, b) => {
      const aDiff = target.diff(a, 'year', true)
      const bDiff = target.diff(b, 'year', true)
      return Math.abs(aDiff) > Math.abs(bDiff) ? b : a
    })
    return document.getElementById(nearestDate)
  }

  scrollToDate(date: DateString) {
    const dateEl = this.getDateElement(date)
    const wrapperEl = document.getElementById(this.wrapperId)
    if (!wrapperEl || !dateEl) return
    const top = this.getElementTop(dateEl)
    wrapperEl.scrollTop = top
  }
}
